import React, { useEffect, useState } from 'react'
import { Box, Button, Tab, Tabs } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { findObjctByValueFromArrayOfObject } from '../../../../common/helper'
import { Item } from '../../../../common/snippets'
import QRTransactionReport from './QRTransactionReport'
import QRBeneficiaryUpdate from './QRBeneficiaryUpdate'

const QRTransactionsPage = () => {
 const [senderSect] = useState(['QR Transaction Report', 'QR Beneficiary Update'])
     const [senderSectContent, setSenderSectContent] = useState(0)
 
     const handleSenderSect = (event, newValue) => {
         setSenderSectContent(newValue)
     }
     function a11yProps(index) {
         return {
             id: `simple-tab-${index}`,
             'aria-controls': `simple-tabpanel-${index}`,
         }
     }
 
     return (
         <>
             <Item
                 sx={{
                     width: '100%',
                     margintTop: '10px',
                     padding: '0px',
                     paddingLeft:'17px'
                     //   paddingLeft: '19px',
                     //  marginRight: '25px',
                 }}
             >
                 <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                     <Tabs value={senderSectContent} onChange={handleSenderSect} aria-label="bsic tabs example">
                         {senderSect.map((reqType, index) => (
                             <Tab key={`sender_${index}`} label={reqType} {...a11yProps(index)} style={{ lineHeight: '2.5' }} />
                         ))}
                     </Tabs>
                 </Box>
             </Item>
             {senderSectContent === 0 ? <QRTransactionReport /> : ''}
             {senderSectContent === 1 ? <QRBeneficiaryUpdate /> : ''}
         </>
     )
}

export default QRTransactionsPage
